module.exports = __webpack_public_path__ + "img/second-3-opened.59baa10f.webp";